/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";

const QuillDeltaHTML = ({ delta }) => {
    // Set configuration options
    //    https://github.com/nozer/quill-delta-to-html
    const quillConfig = {
        multiLineParagraph: false,
    };
    
    const convertToHtml = (delta) => {
        const converter = new QuillDeltaToHtmlConverter(delta.ops, quillConfig);
        return converter.convert();
    };
    
    return (
        <>
            <div className='rich-text-display read-only'
                dangerouslySetInnerHTML={{
                    __html: convertToHtml(delta || { ops: [] }),
                }}
            />
            {/*<JSONDebug obj={delta.ops} />*/}
        </>
    );
    
    // return (
    //     <div className='rich-text-display read-only'>
    //         <div
    //             dangerouslySetInnerHTML={{
    //                 __html: convertToHtml(delta || { ops: [] }),
    //             }}
    //         />
    //         {/*<JSONDebug obj={delta.ops} />*/}
    //     </div>
    // )
};

export { QuillDeltaHTML };
